const MONEY_PLACEHOLDERS = {
  amount: { decimals: 2, thousands: ',', decimal: '.' },
  amount_no_decimals: { decimals: 0, thousands: ',', decimal: '.' },
  amount_with_comma_separator: { decimals: 2, thousands: '.', decimal: ',' },
  amount_no_decimals_with_comma_separator: { decimals: 0, thousands: '.', decimal: ',' },
  amount_with_apostrophe_separator: { decimals: 2, thousands: "'", decimal: '.' },
  amount_no_decimals_with_space_separator: { decimals: 0, thousands: ' ', decimal: ',' },
  amount_with_space_separator: { decimals: 2, thousands: ' ', decimal: ',' },
  amount_with_period_and_space_separator: { decimals: 2, thousands: ' ', decimal: '.' },
};

function groupedAmount(amount, { decimals, thousands, decimal }) {
  const [integer, fraction] = amount.toFixed(decimals).split('.');
  const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
  return fraction ? `${grouped}${decimal}${fraction}` : grouped;
}

const formatTexts = new Map();

function displayedText(format) {
  if (!/[<&]/.test(format)) return format;
  if (!formatTexts.has(format)) {
    const template = document.createElement('template');
    template.innerHTML = format;
    formatTexts.set(format, template.content.textContent);
  }
  return formatTexts.get(format);
}

export function formatMoney(cents, format) {
  if (cents == null) return '';
  const moneyFormat = displayedText(format || window.Scale?.moneyFormat || '{{ amount }}');
  const amount = Math.abs(cents) / 100;

  const result = moneyFormat.replace(/{{\s*(\w+)\s*}}/g, (placeholder, name) => {
    const spec = MONEY_PLACEHOLDERS[name];
    return spec ? groupedAmount(amount, spec) : placeholder;
  });

  return cents < 0 ? `-${result}` : result;
}

export function shopCurrencyAmountToPresentment(amount) {
  const value = Number(amount);
  if (!Number.isFinite(value)) return null;
  const rate = Number(window.Shopify?.currency?.rate);
  if (Number.isFinite(rate) && rate > 0) return value * rate;
  if (window.Scale?.currency && window.Scale?.shopCurrency === window.Scale.currency) return value;
  return null;
}
